import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import "./EditSuitStyle.css"
import { emSuitStuff } from '../model/emSuitStuff';

type AddSuitsProps = {
  suitID: number;
  suitName: string;
  loggedState: number;
  loggedID: String;
}

const EditSuits: React.FC<AddSuitsProps> = ({ suitID, loggedState, suitName }) => {
  const [suitStuff, setSuitStuff] = useState<emSuitStuff[]>([]);
  const navigate = useNavigate();
  const SUIT_TYPES: { id: number; label: string }[] = [
    { id: 0, label: 'Jacke' },
    { id: 1, label: 'Hose' },
    { id: 2, label: 'Flammschutzhaube' },
    { id: 3, label: 'Handschuhe' },
    { id: 4, label: 'Hollandtuch' },
  ];

  const SUIT_STATUS: { id: number; label: string }[] = [
    { id: 0, label: 'Nicht genutzt' },
    { id: 1, label: 'In Benutzung' },
    { id: 2, label: 'Ausgemustert' },
    { id: 3, label: 'Wäsche/Reperatur' },
  ];

  const handleSuitStuffChange = (index: number, field: keyof emSuitStuff, value: string | number) => {
    const updated = [...suitStuff];
    updated[index] = {
      ...updated[index],
      [field]: value,
    };
    setSuitStuff(updated);
  };

  const getTypeHeadline = (type: number | string): string => {
    const numericType = Number(type);
    const found = SUIT_TYPES.find(t => t.id === numericType);
    return found ? found.label : 'Unbekannt';
  };

  useEffect(() => {
    ReadSuitStuff(suitID);
  }, []);

  const ReadSuitStuff = async (suitID: number) => {
    if (suitID !== -1) {
      try {
        const response = await fetch(
          'https://ff-schwebda.de/RescueOfficer/Server/ReadSuitStuff.php',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ suitID }),
          }
        );

        if (response.ok) {
          const data = await response.json();
          setSuitStuff(data);
        } else {
          console.error('Fehler beim Lesen der Garnitur');
        }
      } catch (error) {
        console.error('Fehler beim Request:', error);
      }
    }
  };

  const handleInputChange = async (value: string, column: string, stuffID: number) => {
    try {
      const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/UpdateSuitStuff.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          stuffID,
          column,
          value,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
        if (data.status === 'success') {
          ReadSuitStuff(suitID);
        }
        else {
          alert("Garnitur Stuff konnte nicht aktualisiert werden");
        }

      } else {
        const data = await response.json();
        alert("Garnitur Stuff konnte nicht aktualisiert werden");
      }
    } catch (error) {
      console.error('Fehler beim Request:', error);
    }
  };

  const Save = async () => {
    // später implementieren
  };

  return (
    <div
      className="Edit_Suits_container"
      style={{ visibility: loggedState === 0 ? 'hidden' : 'visible' }}
    >
      <div className="Edit_Suits_emergency_container">

        <div className="Edit_Suits_header">
          <h2>Garnitur bearbeiten</h2>
        </div>

        <div className="Edit_Suits_item_container">
          <label className="Edit_Suits_label">Garnitur ID:</label>
          <input
            type="text"
            className="Edit_Suits_input"
            value={suitID}
            readOnly
          />

          <label className="Edit_Suits_label">Garnitur Name:</label>
          <input
            type="text"
            className="Edit_Suits_input"
            value={suitName}
            readOnly
          />
        </div>

        {suitStuff.map((item, index) => (
          <div className="Edit_Suits_block">

            <div className="Edit_Suits_divider">
              {getTypeHeadline(item.type)}
            </div>

            {/* GRID CONTAINER */}
            <div className="Edit_Suits_grid">

              <div className="Edit_Suits_row">
                <label className="Edit_Suits_label">Hersteller:</label>
                <input
                  className="Edit_Suits_input"
                  value={item.vendor}
                  onChange={(e) => handleSuitStuffChange(index, 'vendor', e.target.value)}
                  onBlur={(e) => handleInputChange(String(e.target.value), 'vendor', item.ID)}
                />
              </div>

              <div className="Edit_Suits_row">
                <label className="Edit_Suits_label">Modell:</label>
                <input
                  className="Edit_Suits_input"
                  value={item.modell}
                  onChange={(e) => handleSuitStuffChange(index, 'modell', e.target.value)}
                  onBlur={(e) => handleInputChange(String(e.target.value), 'modell', item.ID)}
                />
              </div>

              <div className="Edit_Suits_row">
                <label className="Edit_Suits_label">Größe:</label>
                <input
                  className="Edit_Suits_input"
                  value={item.size}
                  onChange={(e) => handleSuitStuffChange(index, 'size', e.target.value)}
                  onBlur={(e) => handleInputChange(String(e.target.value), 'size', item.ID)}
                />
              </div>

              <div className="Edit_Suits_row">
                <label className="Edit_Suits_label">Tag:</label>
                <input
                  className="Edit_Suits_input"
                  value={item.tag}
                  onChange={(e) => handleSuitStuffChange(index, 'tag', e.target.value)}
                  onBlur={(e) => handleInputChange(String(e.target.value), 'tag', item.ID)}
                />
              </div>

              <div className="Edit_Suits_row">
                <label className="Edit_Suits_label">Wäschen:</label>
                <input
                  type="number"
                  className="Edit_Suits_input"
                  value={item.washes}
                  onChange={(e) =>
                    handleSuitStuffChange(index, 'washes', Number(e.target.value))
                  }
                  onBlur={(e) => handleInputChange(String(e.target.value), 'washes', item.ID)}
                />
              </div>

              <div className="Edit_Suits_row">
                <label className="Edit_Suits_label">Status:</label>
                <select
                  className="Edit_Suits_select"
                  value={item.status}
                  onChange={(e) => handleSuitStuffChange(index, 'status', Number(e.target.value))}
                  onBlur={(e) => handleInputChange(String(e.target.value), 'status', item.ID)}
                >
                  {SUIT_STATUS.map(s => (
                    <option key={s.id} value={s.id}>{s.label}</option>
                  ))}
                </select>
              </div>

              <div className="Edit_Suits_row">
                <label className="Edit_Suits_label">In Dienst genommen:</label>
                <input
                  type="date"
                  className="Edit_Suits_input"
                  value={item.firstUse}
                  onChange={(e) =>
                    handleSuitStuffChange(index, 'firstUse', e.target.value)
                  }
                  onBlur={(e) => handleInputChange(String(e.target.value), 'firstUse', item.ID)}
                />
              </div>

               <div className="Edit_Suits_row">
                <label className="Edit_Suits_label">Nächste Prüfung:</label>
                <input
                  type="date"
                  className="Edit_Suits_input"
                  value={item.nextCheck}
                  onChange={(e) =>
                    handleSuitStuffChange(index, 'nextCheck', e.target.value)
                  }
                  onBlur={(e) => handleInputChange(String(e.target.value), 'nextCheck', item.ID)}
                />
              </div>   

              {/* REMARK – über beide Spalten */}
              <div className="Edit_Suits_row Edit_Suits_remark">
                <label className="Edit_Suits_label">Bemerkung:</label>
                <textarea
                  className="Edit_Suits_textarea"
                  value={item.remark}
                  onChange={(e) => handleSuitStuffChange(index, 'remark', e.target.value)}
                  onBlur={(e) => handleInputChange(e.target.value, 'remark', item.ID)}
                />
              </div>

            </div>
          </div>
        ))}
        
      </div>
    </div>
  );
};

export default EditSuits;